module.exports = __webpack_public_path__ + "static/tortle-AYAGWW-09d116a6da7628a1df47a4ae03858bfb.png";